module.exports = __webpack_public_path__ + "static/img/Gallery06.820abb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls46-1/Gallery06.jpg
// module id = y1l2
// module chunks = 12